import React from "react";
import { dispatch } from "@rematch/core";
import { withRouter } from "react-router-dom";
import {
  Grid,
  Icon,
  Popup,
  Card,
  List,
  Image,
  Divider,
} from "semantic-ui-react";
import Progress from "react-progressbar";
import "react-datepicker/dist/react-datepicker.css";
import ProgressCard from "./../../Drive/cards/ProgressCard";
import DaysDifference from "./../../Drive/cards/DaysDifference";
import BreadCrumbs from "./../../Drive/cards/Breadcrumbs";
import ArrangementPane from "./ArrangementPane";
import Labels from "../../../../common/Labels";
import NothingToShow from "../../../../drive/NothingToShow";
import PlaceholderExampleHeaderImage from "../../../../drive/PlaceHolder/PlaceHolderLoading";
import brokenUserImg from "../../../../../images/common/user-avatar.png";
import _ from "lodash";
import EllipsisTooltip from "../../../../common/EllipsisTooltip";
import MetaDatareadonlyView from "../../../../drive/FormBuilder/MetaDataReadOnlyView";
import ShowInitiativeMetaData from "../../../lifecycleDesigner/drive/modals/ShowInitiativeMetaData";

class AdditionalInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        modalFlag:false
    };
  }

  async componentDidMount() {
    dispatch.app.setRouteParams(this.props.match.params);
    let objValidation =
      Object.entries(this.props.selectedDataById).length === 0 &&
      this.props.selectedDataById.constructor === Object;
    if (objValidation) {
      await dispatch.initiatives.getActiveInitiativeDetailsById(
        this.props.match.params.initiativeId
      );
    }
    dispatch.initiatives.setTabName("AdditionalInfo");
  }

  brokenUserImage(ev) {
    ev.target.src = brokenUserImg;
  }

  setMetadataSchemaModalFlag = (flag) => {
    this.setState({ modalFlag: flag });
  };

  render() {
    console.log(this.props);

    return (
      <div className="containerBox overflow-hide">
        <div className="initiative_overall_progress">
          <ArrangementPane {...this.props} />
          <BreadCrumbs {...this.props} />

          <Card className="progressDetail w_100 ">
            <Card.Content className="header_content">
              <Card.Header>
                <strong className="pad_10">Custom Attribute</strong>
                {this.props.selectedOrganisation && 
                this.props.selectedOrganisation.role &&
                this.props.selectedOrganisation.role === "workspaceOwner" ?
                <Icon
                  onClick={() => this.setMetadataSchemaModalFlag(true)}
                  className="float-right text-right"
                  style={{ margin: "10px" }}
                  name="pencil"
                /> : null }
              </Card.Header>
            </Card.Content>
            <Card.Content
              className="Detailed_content pad_10 "
              style={
                this.props.selectedDataById.metaData
                  ? null
                  : { textAlign: "center" }
              }
            >
              {this.props.selectedDataById &&
              this.props.selectedDataById.metaData ? (
                <MetaDatareadonlyView
                  metaData={this.props.selectedDataById.metaData}
                />
              ) : (
                "NA"
              )}
            </Card.Content>
          </Card>
        </div>
        
        <ShowInitiativeMetaData
                open={this.state.modalFlag}
                setMetadataSchemaModalFlag={this.setMetadataSchemaModalFlag}
                selectedInitiative={this.props.selectedDataById}
                metaData={
                    this.props.selectedDataById &&
                    this.props.selectedDataById.metaData
                }
               
                />
      </div>
    );
  }
}

export default withRouter(AdditionalInformation);
